import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { EnergyService } from '../../../../operational-data-common/services/energy.service';

import { ChartBarModel } from '../../models/chart.model';
import { FeaturePropertyKey } from '../../../../../projects/client';

@Component({
  selector: 'app-chart-active-bar-summary',
  templateUrl: './chart-active-bar-summary.component.html',
  styleUrls: ['./chart-active-bar-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartActiveBarSummaryComponent {
  readonly featurePropertyKey = FeaturePropertyKey;

  @Input() activeBar: ChartBarModel;

  get totalBarValue(): number {
    const parts = this.activeBar?.chartBarParts?.filter((part) => part.color) ?? [];
    if (parts.length === 0) {
      return 0;
    }

    const total = parts.reduce((sum, part) => {
      const value = part.value;

      return sum + value;
    }, 0);

    return total;
  }

  constructor(public energyService: EnergyService) {}
}
